// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"28be7b4c","941":"7dc87142"}[chunkId] + ".chunk.js";
};